import React from 'react';
import { Box, Popover as MUIPopover, PopoverProps as MUIPopoverProps, Typography, Button } from '@mui/material';
import { filter, map, forEach, isEmpty } from 'lodash';
import Tile from './Tile';
import { useGetAllNotifications } from '../../services/react-query/notifications/useGetAllNotifications';
import { useToggleNotificationRead } from '../../services/react-query/notifications/useToggleNotificationRead';

type IPopoverProps = Omit<MUIPopoverProps, 'children'>;
type ToggleReadPayload = Record<string, boolean>;

const popOverHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  p: 2,
  borderBottom: '1px solid var(--border-color)',
};

export default function Popover(props: IPopoverProps) {
  const { data: notifications = [] } = useGetAllNotifications({ enabled: true });
  const toggleReadMutation = useToggleNotificationRead();

  const unreadNotifications = filter(notifications, (n) => !n.seen_at);

  const hasNotifications = !isEmpty(notifications);

  const handleMarkAllAsRead = () => {
    const reads: ToggleReadPayload = {};

    forEach(unreadNotifications, (n) => {
      reads[n.uuid] = true;
    });
    toggleReadMutation.mutate(reads);
  };

  return (
    <MUIPopover {...props} sx={{ maxHeight: '60vh', gap: 1 }}>
      <Box sx={popOverHeaderStyles}>
        <Typography variant="h6">Notifications</Typography>
        {!isEmpty(unreadNotifications) && (
          <Button size="small" onClick={handleMarkAllAsRead} sx={{ textTransform: 'none', fontWeight: 500 }}>
            Mark all as read
          </Button>
        )}
      </Box>

      {hasNotifications ? (
        map(notifications, (notification) => <Tile key={notification.uuid} notification={notification} />)
      ) : (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="text.secondary">
            No notifications
          </Typography>
        </Box>
      )}
    </MUIPopover>
  );
}
